import React from "react";
import "./PredictionEntry.css";

type PredictionEntryProps = {
    label: string
    confidence?: number
    top?: boolean

}

function PredictionEntry({label, confidence, top}: PredictionEntryProps) {
    // render the predicted label and a bar representing the confidence value
    // make the top confidence value green
    return (
        <div key={label} className="prediction-entry">
            {label}
            {!!confidence ?
                <div
                    className={"prediction-bar" + (label==="Negative" ? " prediction-green" : label==="Null" ? ' prediction-yellow' : ' prediction-red')}
                    style={{width: (confidence*100).toString() + "%"}}
                />
            : null}
        <div className = 'number-label' >{!!confidence ? confidence.toFixed(4).toString() : null }</div>
        </div>
    );
}

export default PredictionEntry;
